import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import LinkStyled from './styled';
const RouteLink = forwardRef(({ color, fontSize, fontWeight, noRem, underline, inline, children, ...props }, ref) => (_jsx(LinkStyled, { ref: ref, "$color": color, "$fontSize": fontSize, "$fontWeight": fontWeight, "$noRem": noRem, "$underline": underline, "$inline": inline, ...props, children: children })));
RouteLink.displayName = 'RouteLink';
export default memo(RouteLink);
